import { MdClose } from "react-icons/md";
import './close-icon.component.scss';

interface ICloseIcon {
    onClicked: any;
}

const CloseIcon = (props: ICloseIcon) => {
    return (
        <MdClose className="close-icon" color="#8e8d8d" onClick={props.onClicked} />
    )
}

export default CloseIcon;
